export default "__VITE_ASSET__C$RsgP5s__"